import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  LdsButton,
  LdsModal,
  LdsTable,
  LdsPagination,
  LdsSearch,
  LdsCheckbox,
} from "@elilillyco/ux-lds-react";
import "./../../assets/scss/details/addRespModal.scss";
import SortableHeader from "../shared/SortableHeader";

const SearchResponsibilityModal = ({
  isModalOpen,
  setIsModalOpen,
  specialtylist,
  responsibilitylist,
  updateSelectedResponsibility,
  onCancel,
}) => {
  const { respCodeIndex } = useSelector(({ details }) => details);
  const tableHead = ["Responsibility Code", "Description"];
  const [allresponsibilitylist, setallresponsibilitylist] = useState(
    JSON.parse(JSON.stringify(responsibilitylist))
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedSearchTerm, setAppliedSearchTerm] = useState("");
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  let totalPg = Math.ceil(
    allresponsibilitylist.filter((itm) => itm.show).length / itemsPerPage
  );
  let indexOfLastItem = currentPage * itemsPerPage;
  let indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // eslint-disable-next-line no-unused-vars
  const [selcuuid, setselcuuid] = useState([]);

  useEffect(() => {
    if (isModalOpen) {
      setCurrentPage(1);
      let selectedSpecialty = [];
      let indexLst = [];

      indexLst =
        specialtylist.specialties[
          respCodeIndex.payload
        ].responsibility_code.split(",");
      
      for (let i = 0; i < indexLst.length; i++) {
        for (let j = 0; j < responsibilitylist.length; j++) {
          if (indexLst[i].trim().toUpperCase() === responsibilitylist[j].salesforce_code.trim().toUpperCase()) {
            selectedSpecialty.push(responsibilitylist[j].uuid);
          }
        }
      }
      let tempresp = JSON.parse(JSON.stringify(responsibilitylist));
      
      // Check for RC codes that are selected but not in the responsibility list (inactive codes)
      const existingRCCodes = new Set(tempresp.map(rc => rc.salesforce_code.trim().toUpperCase()));
      const selectedRCCodes = indexLst.map(code => code.trim()).filter(code => code !== '');
      const selectedRCCodesUpper = selectedRCCodes.map(code => code.toUpperCase());
      const inactiveRCCodes = [];
      
      selectedRCCodes.forEach((originalCode, index) => {
        if (!existingRCCodes.has(selectedRCCodesUpper[index])) {
          inactiveRCCodes.push(originalCode); // Keep original case
        }
      });
      
      if (inactiveRCCodes.length > 0) {
        // Add inactive RC codes to the list so they can be unchecked/removed
        inactiveRCCodes.forEach(inactiveCode => {
          tempresp.push({
            uuid: `inactive_${inactiveCode.toUpperCase()}`,
            salesforce_code: inactiveCode,
            salesforce_description: 'Inactive Responsibility Code',
            active: false,
            show: true,
            isRespSelected: true // Pre-select it since it's currently assigned
          });
        });
      }
      
      for (let i = 0; i < tempresp.length; i += 1) {
        if (selectedSpecialty.includes(tempresp[i].uuid) || tempresp[i].active === false) {
          tempresp[i]["isRespSelected"] = true;
        }
      }
      
      // Sort alphabetically by salesforce_code with selected items at top
      tempresp.sort((a, b) => {
        // Show selected items at the top
        if (a.isRespSelected && !b.isRespSelected) return -1;
        if (!a.isRespSelected && b.isRespSelected) return 1;
        
        const codeA = a.salesforce_code.toUpperCase();
        const codeB = b.salesforce_code.toUpperCase();
        if (codeA < codeB) return -1;
        if (codeA > codeB) return 1;
        return 0;
      });
      
      setallresponsibilitylist(tempresp);
      setselcuuid(selectedSpecialty);
    } else {
      setSearchTerm("");
      setAppliedSearchTerm("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, respCodeIndex]);
  
  useEffect(() => {
    const temp = JSON.parse(JSON.stringify(allresponsibilitylist));
    let filterdata = temp.map((obj) => {
      if (appliedSearchTerm.trim() === "") {
        // Show all items when no search is applied
        return { ...obj, show: true };
      } else {
        // Support comma-separated search terms
        const searchTerms = appliedSearchTerm.split(',').map(term => term.trim().toLowerCase()).filter(term => term !== '');
        const code = obj.salesforce_code.toLowerCase();
        const description = obj.salesforce_description.toLowerCase();
        
        // Check if any of the search terms match
        const matches = searchTerms.some(term => 
          code.includes(term) || description.includes(term)
        );
        
        return { ...obj, show: matches };
      }
    });
    
    // Sort filtered data alphabetically by salesforce_code
    filterdata.sort((a, b) => {
      // If no search is applied and both items are visible, show selected items at the top
      if (appliedSearchTerm.trim() === "" && a.show && b.show) {
        if (a.isRespSelected && !b.isRespSelected) return -1;
        if (!a.isRespSelected && b.isRespSelected) return 1;
      }
      
      const codeA = a.salesforce_code.toUpperCase();
      const codeB = b.salesforce_code.toUpperCase();
      if (codeA < codeB) return -1;
      if (codeA > codeB) return 1;
      return 0;
    });
    
    setallresponsibilitylist(filterdata);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedSearchTerm]);

  const submitSearch = () => {
    // Update the applied search term which triggers the useEffect to filter
    setAppliedSearchTerm(searchTerm);
    setCurrentPage(1);
  };
  const checkBoxClicked = (event, UUID) => {
    const tempData = JSON.parse(JSON.stringify(allresponsibilitylist));
    for (let i = 0; i < tempData.length; i++) {
      if (UUID === tempData[i].uuid) {
        tempData[i].isRespSelected = event.target.checked;
      }
    }
    setallresponsibilitylist(tempData);
  };
  const closeModal = () => {
    // Simply close the modal without saving changes
    // Changes are only saved when user clicks the "Save" button
    setSearchTerm("");
    setAppliedSearchTerm("");
    setIsModalOpen(false);
    if (onCancel) onCancel();
  };
  
  // Custom handler for modal close that handles both Cancel button and clicking outside
  const handleModalClose = (isOpen) => {
    if (!isOpen) {
      setSearchTerm("");
      setAppliedSearchTerm("");
      if (onCancel) onCancel();
    }
    // Simply update modal state without saving changes
    // Changes are only saved when user clicks the "Save" button
    setIsModalOpen(isOpen);
  };
  
  const handleAddForm = () => {
    const filterdata = allresponsibilitylist
      .filter((obj) => obj.isRespSelected === true)
      .map((obj) => obj.salesforce_code)
      .join(",");
    updateSelectedResponsibility(filterdata);
    setSearchTerm("");
    setAppliedSearchTerm("");
    setIsModalOpen(false);
  };
  
  // Select all responsibility codes in the current filtered data
  const selectAllResponsibilities = () => {
    const tempData = JSON.parse(JSON.stringify(allresponsibilitylist));
    
    // Only select items that are currently visible (show: true)
    for (let i = 0; i < tempData.length; i++) {
      if (tempData[i].show) {
        tempData[i].isRespSelected = true;
      }
    }
    
    setallresponsibilitylist(tempData);
  };
  
  // Unselect all responsibility codes in the current filtered data
  const unselectAllResponsibilities = () => {
    const tempData = JSON.parse(JSON.stringify(allresponsibilitylist));
    
    // Only unselect items that are currently visible (show: true)
    for (let i = 0; i < tempData.length; i++) {
      if (tempData[i].show) {
        tempData[i].isRespSelected = false;
      }
    }
    
    setallresponsibilitylist(tempData);
  };
  
  // Toggle between select all and unselect all
  const toggleSelectAll = () => {
    const visibleItems = allresponsibilitylist.filter(item => item.show);
    const allSelected = visibleItems.every(item => item.isRespSelected === true);
    
    if (allSelected) {
      unselectAllResponsibilities();
    } else {
      selectAllResponsibilities();
    }
  };
  
  // Determine button text based on selection state
  const getSelectButtonText = () => {
    const visibleItems = allresponsibilitylist.filter(item => item.show);
    const allSelected = visibleItems.every(item => item.isRespSelected === true);
    return allSelected ? "Unselect All" : "Select All";
  };

  return (
    <>
      <LdsModal
        modalId="searchResponsibilityModal"
        open={isModalOpen}
        setModalOpen={handleModalClose}
        heading="Select Responsibility Code"
      >
        <div className="row search-row">
          <div className="col-12 col-md-6">
            <strong>Search Responsibility Code or Description </strong>
            <LdsSearch
              id={"searchResponsibility"}
              onChange={setSearchTerm}
              value={searchTerm}
              onSubmit={submitSearch}
            />
          </div>
          <div className="col-6 button-col">
            {allresponsibilitylist.filter((itm) => itm.show).length > 0 && (
              <LdsButton
                iconPosition="before"
                classes="button-icon-left blue-bdr-btn"
                onClick={toggleSelectAll}
              >
                {getSelectButtonText()}
              </LdsButton>
            )}
          </div>
        </div>

        {allresponsibilitylist.filter((itm) => itm.show).length <= 0 ? (
          <p className="no-record-message">No Record Found</p>
        ) : (
          <div>
            <LdsTable id="specialities-table" flat>
              <thead>
                <tr>
                  <SortableHeader
                    headAlign={"align-left b"}
                    header={tableHead}
                    rowData={allresponsibilitylist}
                    rowKeyName={["salesforce_code", "salesforce_description"]}
                    sortedRowData={setallresponsibilitylist}
                  />
                </tr>
              </thead>
              <tbody>
                {allresponsibilitylist
                  .filter((itm) => itm.show)
                  .map(
                    (itm, index) =>
                      index >= indexOfFirstItem &&
                      index < indexOfLastItem && (
                        <tr key={itm.uuid} style={itm.active === false ? { backgroundColor: '#f8d7da', borderLeft: '4px solid #dc3545' } : {}}>
                          <td>
                            <LdsCheckbox
                              required={false}
                              value={itm.uuid}
                              name={"Responsibility-checkbox-" + itm.uuid}
                              id={"Responsibility-checkbox-" + itm.uuid}
                              onChange={(event) =>
                                checkBoxClicked(event, itm.uuid)
                              }
                              checked={itm.isRespSelected}
                            ></LdsCheckbox>
                            <span style={itm.active === false ? { color: '#dc3545', fontWeight: 'bold' } : {}}>
                              {itm.salesforce_code}
                            </span>
                            {itm.active === false && (
                              <span style={{ 
                                color: '#dc3545', 
                                fontSize: '0.85em', 
                                marginLeft: '8px',
                                fontWeight: 'bold',
                                backgroundColor: '#fff',
                                padding: '2px 6px',
                                borderRadius: '3px',
                                border: '1px solid #dc3545'
                              }}>
                                INACTIVE
                              </span>
                            )}
                          </td>
                          <td>
                            <span style={itm.active === false ? { color: '#dc3545', fontWeight: 'bold' } : {}}>
                              {itm.salesforce_description}
                            </span>
                            {itm.active === false && (
                              <div style={{ 
                                color: '#721c24', 
                                fontSize: '0.9em', 
                                fontWeight: '600',
                                marginTop: '6px',
                                padding: '4px 8px',
                                backgroundColor: '#fff',
                                border: '1px solid #dc3545',
                                borderRadius: '4px'
                              }}>
                                ⚠️ This RC code has been deactivated. Please remove it by unchecking the box.
                              </div>
                            )}
                          </td>
                        </tr>
                      )
                  )}
              </tbody>
            </LdsTable>
            <div className="row">
              <div className="col">
                <LdsPagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={totalPg}
                  className="mt-4"
                />
              </div>
            </div>
          </div>
        )}
        <div className="floatRight">
          <LdsButton
            iconPosition="before"
            classes="button-icon-left blue-bdr-btn"
            onClick={closeModal}
          >
            Cancel
          </LdsButton>
          <span className="buttonMargin">
            <LdsButton
              iconPosition="before"
              classes="button-icon-left blue-btn"
              onClick={handleAddForm}
            >
              Select
            </LdsButton>
          </span>
        </div>
      </LdsModal>
    </>
  );
};
export default SearchResponsibilityModal;
